// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-container {
  width: auto;
  padding-top: 32px;
  padding-right: 31px;
  z-index: 111;
  position: fixed;
  right: 0px;
}
.menu-container .menu-button {
  width: 60px;
  height: 60px;
  background-color: rgba(39, 39, 46, 0.4);
  border-radius: 200px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/components/menu-button/menu-button.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,uCAAA;EAEA,oBAAA;AAAJ","sourcesContent":[".menu-container {\r\n  width: auto;\r\n  padding-top: 32px;\r\n  padding-right: 31px;\r\n  z-index: 111;\r\n  position: fixed;\r\n  right: 0px;\r\n\r\n  .menu-button {\r\n    width: 60px;\r\n    height: 60px;\r\n    background-color: rgba(39, 39, 46, 0.4);\r\n\r\n    border-radius: 200px;\r\n    // display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
